/* unplugin-vue-components disabled */import { render } from "./mobile-footer.vue?vue&type=template&id=55bb4f06&scoped=true&ts=true"
import script from "./mobile-footer.vue?vue&type=script&lang=ts"
export * from "./mobile-footer.vue?vue&type=script&lang=ts"

import "./mobile-footer.vue?vue&type=style&index=0&id=55bb4f06&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bb4f06"]])

export default __exports__